export const CATEGORIES_CSV_FIELD = ['_id', 'name', 'color', 'user_type', 'category_1', 'category_2', 'category_3']

export const CARD_CSV_FIELD = ['_id', 'san_id', 'user_id', 'user_name', 'category_name']

export const BEACON_CARRIED_FIELD = ['_id', 'beacon_uuid', 'major', 'minor']
